




	import Vue from 'vue';

    export default Vue.extend({
        name: "ModListUserBodyRoleComp",
        props: ['role'],
        computed: {
            color: function(): string {
                if (this.role.color === '#000000') {
                    return '#ffffff';
                } else {
                    return this.role.color;
                }
            }
        }
    })
